import React from 'react';
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from "./ui/alert-dialog";
import { Trash2 } from 'lucide-react';

const ConfirmDialog = ({
    isOpen,
    onClose,
    onConfirm,
    title = "Emin misiniz?",
    description = "Bu işlem geri alınamaz. Bu veriyi kalıcı olarak silecektir.",
    confirmText = "Sil",
    cancelText = "İptal",
    variant = "destructive"
}) => {
    return (
        <AlertDialog open={isOpen} onOpenChange={onClose}>
            <AlertDialogContent className="bg-[#1a1a1b] border-gray-800 text-white shadow-2xl">
                <AlertDialogHeader>
                    <div className="flex items-center gap-3 mb-2">
                        <div className="p-2 rounded-full bg-red-500/10">
                            <Trash2 className="w-5 h-5 text-red-500" />
                        </div>
                        <AlertDialogTitle className="text-xl font-black tracking-tight text-white italic uppercase">
                            {title}
                        </AlertDialogTitle>
                    </div>
                    <AlertDialogDescription className="text-gray-400 font-medium">
                        {description}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter className="mt-4 gap-2">
                    <AlertDialogCancel
                        onClick={onClose}
                        className="bg-transparent border-gray-700 text-gray-400 hover:text-white hover:bg-white/5 font-bold px-6"
                    >
                        {cancelText}
                    </AlertDialogCancel>
                    <AlertDialogAction
                        onClick={(e) => {
                            e.preventDefault();
                            onConfirm();
                            onClose();
                        }}
                        className={`${variant === 'destructive'
                                ? 'bg-red-600 hover:bg-red-700'
                                : 'bg-blue-600 hover:bg-blue-700'
                            } text-white font-black px-6 shadow-lg shadow-red-900/20`}
                    >
                        {confirmText}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};

export default ConfirmDialog;
